/* eslint-disable react/prop-types */
import React from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import '../css/Warehouse.css';
import { Route, Switch } from 'react-router-dom';
import FormAddUser from './FormAddUser';
import ListUser from './ListUser';
import MyUtil from '../../functions/MyUtil';

const User = ({ match }) => {
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListUser match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route path={`${match.url}/add`} component={FormAddUser} />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route path={`${match.url}/edit/:user_id`} component={FormAddUser} />
        )}
      </Switch>
    </div>
  );
};

export default User;
